import { Component, Host, h, State, Event, EventEmitter, Prop } from '@stencil/core';
import { DomService } from '../../services';

@Component({
  tag: 'rcm-high-contrast-toggle',
  styleUrl: 'rcm-high-contrast-toggle.scss',
  shadow: true,
})
export class RcmHighContrastToggle {
  @Prop() skipLink = false;

  @State() isChecked = false;

  @Event({ eventName: 'rcmHighContrastToggle' })
  private highContrastToggleEvent: EventEmitter;

  getToggleInputElement = (target) => {
    const highContrastToggle = target.shadowRoot.querySelector('rcm-high-contrast-toggle');
    const highContrastToggleInput = highContrastToggle.shadowRoot.querySelector('input');

    return highContrastToggleInput;
  };

  toggleContrast() {
    const navigation = document.querySelector('rcm-navigation');
    const footer = document.querySelector('rcm-footer');

    if (document.body.classList.contains('high-contrast')) {
      document.body.classList.remove('high-contrast');
      this.isChecked = false;
    } else {
      document.body.classList.add('high-contrast');
      this.isChecked = true;
    }

    this.getToggleInputElement(footer).checked = this.isChecked;
    if (navigation) {
      this.getToggleInputElement(navigation).checked = this.isChecked;
    }
    this.highContrastToggleEvent.emit();
  }

  render() {
    const footerVars = DomService.getGlobalContent().footer;
    return (
      <Host>
        {footerVars && footerVars.contrastToggle && (
          <div class="toggle-wrapper" onClick={() => this.toggleContrast()}>
            <input checked={this.isChecked} type="checkbox" class="toggle" />
            <label
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  this.toggleContrast();
                }
              }}
              tabIndex={0}
              htmlFor="toggle"
              class="toggle__switcher"
            ></label>
            <label
              htmlFor="toggle"
              class={{
                toggle__label: true,
                'toggle__skip-link': this.skipLink,
              }}
            >
              {footerVars.contrastToggle}
            </label>
          </div>
        )}
      </Host>
    );
  }
}
